import React from 'react';
import { Helmet } from 'react-helmet-async';

const CONCEPTS = [
  { id: 1, name: 'Geometric R Monogram', desc: 'Clean "R" in a rounded square. Professional, versatile, works at any size.' },
  { id: 2, name: 'Circuit Node R', desc: 'R inside a circle with node dots — represents connectivity, networks, automation.' },
  { id: 3, name: 'Lightning Bolt R', desc: 'Abstract bolt/arrow shape — conveys speed, power, automation energy.' },
  { id: 4, name: 'Stacked Bars R', desc: 'Horizontal bars forming an R — data/analytics feel, structured and technical.' },
  { id: 5, name: 'Hexagonal R', desc: 'R inside a hexagon — engineering, structure, precision. Classic tech mark.' },
];

const Logos = () => {
  return (
    <>
      <Helmet>
        <title>Logo Concepts | Rishant Technologies</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <main style={{ paddingTop: '80px', backgroundColor: '#F5F0E8', minHeight: '100vh' }}>
        {/* Header */}
        <section style={{ padding: 'clamp(3rem, 6vw, 5rem) 1.5rem 2rem' }}>
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            <h1 style={{
              fontSize: 'clamp(2rem, 4vw, 3rem)',
              fontWeight: 700,
              letterSpacing: '-0.03em',
              color: '#1A1A1A',
              fontFamily: '"DM Sans", sans-serif',
              marginBottom: '0.5rem',
            }}>
              Logo Concepts
            </h1>
            <p style={{
              fontSize: '1rem',
              color: '#666666',
              fontFamily: '"DM Sans", sans-serif',
            }}>
              5 concepts for Rishant Technologies — each with light/dark variants and favicon
            </p>
          </div>
        </section>

        {/* Concepts */}
        <section style={{ padding: '0 1.5rem 5rem' }}>
          <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
            {CONCEPTS.map((c) => (
              <div key={c.id} style={{ marginBottom: '4rem' }}>
                {/* Title */}
                <h2 style={{
                  fontSize: '1.15rem',
                  fontWeight: 700,
                  color: '#1A1A1A',
                  fontFamily: '"DM Sans", sans-serif',
                  marginBottom: '0.25rem',
                }}>
                  Concept {c.id} — {c.name}
                </h2>
                <p style={{
                  fontSize: '0.875rem',
                  color: '#666666',
                  fontFamily: '"DM Sans", sans-serif',
                  marginBottom: '1.25rem',
                }}>
                  {c.desc}
                </p>

                {/* Logo row */}
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr',
                  gap: '1rem',
                  marginBottom: '1.5rem',
                }} className="logo-preview-grid">
                  <div style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #E0D8CC' }}>
                    <img
                      src={`/logos/logo-${c.id}-light-bg.svg`}
                      alt={`${c.name} light`}
                      style={{ width: '100%', display: 'block' }}
                    />
                    <div style={{
                      fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase',
                      letterSpacing: '0.08em', color: '#999', padding: '8px 12px',
                      background: '#FFFFFF', fontFamily: '"DM Sans", sans-serif',
                    }}>
                      Light Background
                    </div>
                  </div>
                  <div style={{ borderRadius: '12px', overflow: 'hidden', border: '1px solid #E0D8CC' }}>
                    <img
                      src={`/logos/logo-${c.id}-dark-bg.svg`}
                      alt={`${c.name} dark`}
                      style={{ width: '100%', display: 'block' }}
                    />
                    <div style={{
                      fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase',
                      letterSpacing: '0.08em', color: '#999', padding: '8px 12px',
                      background: '#FFFFFF', fontFamily: '"DM Sans", sans-serif',
                    }}>
                      Dark Background
                    </div>
                  </div>
                </div>

                {/* Favicon */}
                <div>
                  <div style={{
                    fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase',
                    letterSpacing: '0.08em', color: '#999', marginBottom: '0.75rem',
                    fontFamily: '"DM Sans", sans-serif',
                  }}>
                    Favicon
                  </div>
                  <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center' }}>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src={`/logos/favicon-${c.id}.svg`}
                        alt={`Favicon ${c.id}`}
                        style={{ width: '64px', height: '64px', borderRadius: '14px', border: '1px solid #E0D8CC' }}
                      />
                      <span style={{ display: 'block', fontSize: '0.7rem', color: '#999', marginTop: '6px', fontFamily: '"DM Sans", sans-serif' }}>
                        64 &times; 64
                      </span>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src={`/logos/favicon-${c.id}.svg`}
                        alt={`Favicon ${c.id} small`}
                        style={{ width: '32px', height: '32px', borderRadius: '7px', border: '1px solid #E0D8CC' }}
                      />
                      <span style={{ display: 'block', fontSize: '0.7rem', color: '#999', marginTop: '6px', fontFamily: '"DM Sans", sans-serif' }}>
                        32 &times; 32
                      </span>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <img
                        src={`/logos/favicon-${c.id}.svg`}
                        alt={`Favicon ${c.id} tiny`}
                        style={{ width: '16px', height: '16px', borderRadius: '3px', border: '1px solid #E0D8CC' }}
                      />
                      <span style={{ display: 'block', fontSize: '0.7rem', color: '#999', marginTop: '6px', fontFamily: '"DM Sans", sans-serif' }}>
                        16 &times; 16
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      <style>{`
        @media (min-width: 640px) {
          .logo-preview-grid { grid-template-columns: 1fr 1fr !important; }
        }
      `}</style>
    </>
  );
};

export default Logos;
